import Button from './button'
import Icon, {icons} from './icon'
import Input from './input'
import PropTypes from 'prop-types'
import React, {Fragment} from 'react'
import {Formik} from './formik'
import {colors, media, text} from '../styles'
import {connect} from 'react-redux'
import {css} from 'glamor'
import {subscribe} from '../redux/actions/newsletter'

const style = {
  container: css({
    ...media.xs({
      '& input, & button': {
        borderRadius: '0 !important'
      }
    })
  }),
  left: css({
    float: 'left',
    width: '80%',
    ...media.xs({
      width: '90%'
    })
  }),
  right: css({
    float: 'right',
    width: '18%',
    ...media.xs({
      width: '10%'
    })
  }),
  button: css({
    height: '50px !important',
    lineHeight: '50px !important'
  }),
  errorMessage: css({
    color: colors.inputBorderError,
    margin: '0 0 10px'
  }),
  title: css(text.h4, {
    fontWeight: 'normal',
    margin: '0 0 5px'
  })
}

const InnerForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  placeholder,
  status,
  touched,
  values
}) => {
  if (status && status.success) {
    return (
      <Fragment>
        <h5 {...style.title}>
          <strong>SCORE!</strong>
        </h5>
        <p>You’ve successfully subscribed.</p>
      </Fragment>
    )
  }

  return (
    <form onSubmit={handleSubmit} {...style.container}>
      <div {...style.left}>
        <Input
          compact
          autoComplete="email"
          label={placeholder}
          name="Email"
          onBlur={handleBlur}
          onChange={handleChange}
          size="block"
          type="email"
          required
          valid={touched.Email ? !errors.Email : undefined}
          value={values.Email}
        />
        {touched.Email && errors.Email && (
          <div className="error-message" {...style.errorMessage}>
            {errors.Email}
          </div>
        )}
      </div>
      <div {...style.right}>
        <Button block disabled={isSubmitting} size="small" type="submit">
          <span className="hidden-xs">Subscribe</span>
          <span className="visible-xs">
            <Icon icon={icons.chevronRight} />
          </span>
        </Button>
      </div>
      <div className="clearfix" />
    </form>
  )
}

InnerForm.propTypes = {
  errors: PropTypes.shape({
    Email: PropTypes.string
  }),
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  status: PropTypes.shape({
    success: PropTypes.bool
  }),
  touched: PropTypes.shape({
    Email: PropTypes.bool
  }),
  values: PropTypes.shape({
    Email: PropTypes.string
  })
}

export const NewsletterSignup = ({subscribeEmail, placeholder}) => {
  return (
    <Formik
      initialValues={{Email: ''}}
      onSubmit={(values, {setStatus, setSubmitting, setErrors}) => {
        subscribeEmail(values.Email).then(
          ({body: {signUpSuccess = false, errors = []}}) => {
            if (signUpSuccess) {
              setStatus({
                success: true
              })
            } else if (errors.length !== 0) {
              setSubmitting(false)

              setErrors({
                Email: errors[0]
              })
            } else {
              setSubmitting(false)

              setErrors({
                Email: 'A network error occurred. Please try again.'
              })
            }
          }
        )
      }}
      render={(props) => <InnerForm placeholder={placeholder} {...props} />}
    />
  )
}

NewsletterSignup.propTypes = {
  placeholder: PropTypes.string,
  subscribeEmail: PropTypes.func.isRequired
}

NewsletterSignup.defaultProps = {
  placeholder: 'Email'
}

const dispatchToProps = (dispatch) => ({
  subscribeEmail: (email) => dispatch(subscribe({email}))
})

export default connect(() => ({}), dispatchToProps)(NewsletterSignup)
